import Image from 'next/image'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Center } from '../bases/Center'
import { HStack } from '../bases/HStack'
import { Space } from '../bases/Space'
import { Text } from '../bases/Text'
import { VStack } from '../bases/VStack'
import NoData from '@/public/images/noData.png'

type InstallationData = { titleKey: string; value?: number | string; suffix?: string; isComma?: boolean }

export type Props = {
  visibleNoData: boolean
  datas: Array<InstallationData>
}

export const InstallationStatus = (props: Props) => {
  const { t } = useTranslation()
  return (
    <VStack className="min-h-[400px] w-full rounded-xl border border-[#805BE7] bg-black p-5">
      <Text className="text-lg font-bold text-white">{t('InstallationStatus.statusAreaTitle')}</Text>
      {props.visibleNoData ? (
        <Center className="h-full w-full">
          <Image width={140} height={140} src={NoData} alt="No Data" />
        </Center>
      ) : (
        props.datas.map((data) => {
          const showValue = data.value || data.value === 0
          return (
            <HStack key={data.titleKey} className="items-center px-3 py-2">
              <Text className={`text-lg ${showValue ? 'text-white' : 'text-gray-600'}`}>
                {t(`InstallationStatus.${data.titleKey}`)}
              </Text>
              <Space />
              {showValue ? (
                <Text className="text-xl font-bold text-neon-blue">
                  {data.isComma ? (data.value || 0).toLocaleString() : data.value}
                  {data.suffix}
                </Text>
              ) : (
                <NoValue />
              )}
            </HStack>
          )
        })
      )}
    </VStack>
  )
}

const NoValue = () => <Text className="text-lg font-bold text-gray-700">-</Text>
